/**
 * @generated SignedSource<<e7de8c2b8a025deeda3cda35a924b0a6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type connectModelDialogQuery$variables = {
  salesChannelID: string;
  sku: string;
};
export type connectModelDialogQuery$data = {
  readonly merchantProductOptions: ReadonlyArray<{
    readonly isGlobal: boolean;
    readonly label: string;
    readonly optionID: string;
    readonly salesChannelID: number;
    readonly sku: string | null;
    readonly values: ReadonlyArray<{
      readonly label: string;
      readonly valueID: string;
    }>;
  }>;
};
export type connectModelDialogQuery = {
  response: connectModelDialogQuery$data;
  variables: connectModelDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "salesChannelID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sku"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "salesChannelID",
        "variableName": "salesChannelID"
      },
      {
        "kind": "Variable",
        "name": "sku",
        "variableName": "sku"
      }
    ],
    "concreteType": "MerchantProductGraphQLOption",
    "kind": "LinkedField",
    "name": "merchantProductOptions",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "salesChannelID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "optionID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sku",
        "storageKey": null
      },
      (v2/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isGlobal",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MerchantProductGraphQLOptionValue",
        "kind": "LinkedField",
        "name": "values",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "valueID",
            "storageKey": null
          },
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "connectModelDialogQuery",
    "selections": (v3/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "connectModelDialogQuery",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "cacheID": "f27e9f08cd726dab18cb388f1b3506bd",
    "id": null,
    "metadata": {},
    "name": "connectModelDialogQuery",
    "operationKind": "query",
    "text": "query connectModelDialogQuery(\n  $sku: String!\n  $salesChannelID: ID!\n) {\n  merchantProductOptions(sku: $sku, salesChannelID: $salesChannelID) {\n    salesChannelID\n    optionID\n    sku\n    label\n    isGlobal\n    values {\n      valueID\n      label\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e46f54e0e6a18c261c53f5ed46ada0dc";

export default node;
